import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  monitoringTypeArray,
  platformsArray,
  frequencyArray,
  scopeArray,
  reportingRequirementsArray,
} from './SharedConstants';

const coverageArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Own', label: 'Own' },
  { value: 'Competitors', label: 'Competitors' },
  { value: 'Both', label: 'Both' },
];

const onlineReputationPages = [
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineReputation,
    fields: [
      {
        fieldName: 'MonitoringType',
        label: 'Online monitoring or Online Reputation management?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(monitoringTypeArray.map(m => m.label)),
      },
      {
        fieldName: 'PlatformsToMonitor',
        label: 'Media/Internet Platforms',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: platformsArray,
      },
      {
        fieldName: 'FrequencyOfMonitoring',
        label: 'Frequency of Monitoring',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(frequencyArray.map(f => f.label)),
      },
      {
        fieldName: 'LanguagesToMonitor',
        label: 'Languages to Monitor',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'Keywords',
        label: 'Keywords',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GoalOfProgram',
        label: 'Goal of the program',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'ScopeOfMonitoring',
        label: 'Scope of Monitoring',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: scopeArray,
      },
      {
        fieldName: 'Coverage',
        label: 'Coverage',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(coverageArray.map(c => c.label)),
      },
      {
        fieldName: 'ClientGuidelines',
        label: 'Client Guidelines',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
  {
    label: 'Reporting Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.OnlineReputation,
    fields: [
      {
        fieldName: 'ReportingRequirements',
        label: 'Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: reportingRequirementsArray,
      },
    ],
  },
];

export default onlineReputationPages;
